import { CodeBlock } from '@atlaskit/code';
import { codeSetUpThemes, codeSetUpThemesShorthand, codeHtmlTheme, codeUseTokens, codeBabelPlugin, codeBabelPluginUsage, codeBabelPluginCompiled, codeFallbackRemovalCodemod, codeLintRules } from "../../../../src/snippets/code/use-tokens-in-code";
import * as React from 'react';
export default {
  CodeBlock,
  codeSetUpThemes,
  codeSetUpThemesShorthand,
  codeHtmlTheme,
  codeUseTokens,
  codeBabelPlugin,
  codeBabelPluginUsage,
  codeBabelPluginCompiled,
  codeFallbackRemovalCodemod,
  codeLintRules,
  React
};